import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Button, Drawer } from "antd";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import { motion } from "motion/react";
import logo from '../../assets/logo.png'

const ease = [0.22, 1, 0.36, 1];

const navLinks = [
  { name: "Home", to: "/" },
  { name: "About", to: "/about" },
  { name: "Treatments", to: "/treatments" },
  { name: "News/Articles", to: "/articles" },
];

const linkClass = ({ isActive }) =>
  `text-brand-forest hover:text-brand-gold transition-colors relative group ${
    isActive ? "text-brand-gold" : ""
  }`;

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed top-0 w-full z-50 bg-brand-beige border-b border-brand-lightgold shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="flex justify-between items-center h-20">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease }}
          >
          
            <Link to="/" className="flex items-center cursor-pointer">
              <motion.img
                    whileHover={{ scale: 1.08 }}
                    transition={{ duration: 0.6 }}
                    src={logo}
                    alt=""
                    className="h-[60px] w-full object-cover"
                  />
            </Link>
          </motion.div>

          <motion.div
            initial="hidden"
            animate="visible"
            variants={{
              hidden: { opacity: 0 },
              visible: { opacity: 1, transition: { staggerChildren: 0.1, delayChildren: 0.2 } },
            }}
            className="hidden md:flex items-center gap-8 text-[13px] font-bold tracking-wider uppercase opacity-80"
          >
            {navLinks.map((link) => (
              <motion.div
                key={link.name}
                variants={{
                  hidden: { opacity: 0, y: -10 },
                  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease } },
                }}
              >
                <NavLink to={link.to} className={linkClass}>
                  {link.name}
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-brand-gold transition-all duration-300 group-hover:w-full"></span>
                </NavLink>
              </motion.div>
            ))}
            <motion.div
              variants={{
                hidden: { opacity: 0, scale: 0.9 },
                visible: { opacity: 1, scale: 1, transition: { duration: 0.5, ease } },
              }}
            >
              <Link to="/appointment">
                <Button
                  type="primary"
                  shape="round"
                  size="large"
                  className="!bg-brand-forest hover:!bg-brand-gold !border-none !font-bold !uppercase !tracking-widest !text-[12px] !h-auto !px-6 !py-2"
                >
                  Book Appointment
                </Button>
              </Link>
            </motion.div>
          </motion.div>

          <div className="md:hidden flex items-center">
            <Button
              type="text"
              onClick={() => setIsOpen(true)}
              icon={<MenuOutlined className="text-brand-forest text-xl" />}
            />
          </div>
        </div>
      </div>

      <Drawer
        placement="right"
        title={<span className="text-brand-forest font-bold text-lg">MENU</span> 
}
        onClose={() => setIsOpen(false)}
        open={isOpen}
        closeIcon={<CloseOutlined className="text-brand-forest" />}
        styles={{ body: { backgroundColor: "#FDFCF8", padding: 0 } }}
        width={280}
      >
      
        <div className="px-4 pt-4 pb-6 space-y-1">
          {navLinks.map((link) => (
            <NavLink
              key={link.name}
              to={link.to}
              onClick={() => setIsOpen(false)}
              className="block px-3 py-3 text-[13px] font-bold tracking-wider uppercase text-brand-forest hover:text-brand-gold hover:bg-brand-emerald/20 rounded-lg transition-colors"
            >
              {link.name}
            </NavLink>
          ))}
          <div className="pt-4 px-3">
            <Link to="/appointment" onClick={() => setIsOpen(false)}>
              <Button
                type="primary"
                shape="round"
                block
                size="large"
                className="!bg-brand-forest hover:!bg-brand-gold !border-none !font-bold !uppercase !tracking-widest !text-[12px]"
              >
                Book Appointment
              </Button>
            </Link>
          </div>
        </div>
      </Drawer>
    </nav>
  );
}
